import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f068631"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "img-container"
}
const _hoisted_4 = {
  key: 0,
  class: "img-container-thumb"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "img-container-thumb-cover" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Read more", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 2,
  class: "img-caption"
}
const _hoisted_11 = {
  key: 0,
  class: "img-title"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "img-desc"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "splide__arrows" }
const _hoisted_17 = { class: "splide__arrow splide__arrow--prev" }
const _hoisted_18 = { class: "splide__arrow splide__arrow--next" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thumb-slider__dot" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_arrow_link = _resolveComponent("icon-arrow-link")!
  const _component_icon_linkedin = _resolveComponent("icon-linkedin")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_SplideTrack = _resolveComponent("SplideTrack")!
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!
  const _component_Splide = _resolveComponent("Splide")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["images-slider", 'images-slider-' + _ctx.id])
    }, [
      _createVNode(_component_Splide, {
        "has-track": false,
        options: _ctx.mainOptions,
        class: "main-slider",
        ref: "mainSlider",
        extensions: _ctx.extensions
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SplideTrack, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (slide, index) => {
                return (_openBlock(), _createBlock(_component_SplideSlide, { key: index }, {
                  default: _withCtx(() => [
                    (Array.isArray(slide))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide, (item, itemIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: itemIndex,
                              class: "img-container"
                            }, [
                              _createElementVNode("figure", {
                                class: _normalizeClass(_ctx.imageClass)
                              }, [
                                _createElementVNode("img", {
                                  src: item.url,
                                  alt: 
                      item.title + (item.subtitle ? ' ' + item.subtitle : '')
                    
                                }, null, 8, _hoisted_2)
                              ], 2)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_ctx.id === 'stories')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("figure", {
                                  class: _normalizeClass(_ctx.imageClass)
                                }, [
                                  _createElementVNode("img", {
                                    src: slide.url,
                                    alt: 
                      slide.title + (slide.subtitle ? ' ' + slide.subtitle : '')
                    
                                  }, null, 8, _hoisted_5)
                                ], 2),
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", null, [
                                    _hoisted_7,
                                    _hoisted_8,
                                    _createVNode(_component_icon_arrow_link)
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("figure", {
                                key: 1,
                                class: _normalizeClass(_ctx.imageClass)
                              }, [
                                _createElementVNode("img", {
                                  src: slide.url,
                                  alt: 
                    slide.title + (slide.subtitle ? ' ' + slide.subtitle : '')
                  
                                }, null, 8, _hoisted_9)
                              ], 2)),
                          (_ctx.showTitle || _ctx.showDesc)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (_ctx.showTitle)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      (_ctx.id === 'stories')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("span", null, _toDisplayString(slide.subtitle), 1),
                                            _createElementVNode("span", null, _toDisplayString(slide.title), 1)
                                          ]))
                                        : (_ctx.id !== 'stories')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(slide.title) + " " + _toDisplayString(slide.subtitle), 1))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.showDesc)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(slide.desc), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.id === 'people' && slide.linkedin)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      href: slide.linkedin,
                                      rel: "nofollow noopener",
                                      target: "_blank"
                                    }, [
                                      _createVNode(_component_icon_linkedin)
                                    ], 8, _hoisted_15))
                                  : _createCommentVNode("", true),
                                (_ctx.id === 'stories' && slide.slug)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 3,
                                      to: '/success-stories/' + slide.slug
                                    }, null, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", _hoisted_17, [
              _createVNode(_component_icon_arrow_right)
            ]),
            _createElementVNode("button", _hoisted_18, [
              _createVNode(_component_icon_arrow_right)
            ])
          ])
        ]),
        _: 1
      }, 8, ["options", "extensions"])
    ], 2),
    _createVNode(_component_Splide, {
      "has-track": false,
      options: _ctx.thumbOptions,
      class: "thumb-slider",
      ref: "thumbSlider"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SplideTrack, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (slide, index) => {
              return (_openBlock(), _createBlock(_component_SplideSlide, { key: index }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["options"])
  ]))
}